import B_Animate from '../../../base/dev/animate/B_Animate';
import B_ProtonParticle from '../../../base/dev/animate/proton/B_ProtonParticle';
import R_TweenObject from './tween/R_TweenObject';

const init = () => {
    return class R_Animate extends B_Animate {
        constructor(canvas) {
            super(canvas, new R_TweenObject(canvas), new B_ProtonParticle(canvas));
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/animate/R_Animate.js